module.exports = __webpack_public_path__ + "img/BShieldBearer64_ua.002ddf7a.webp";